

























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import Button from "../../components/Button.vue";
import SinglePeoplePending from "../../components/SinglePeoplePending.vue";
import FilterBox from "../../components/FilterBox.vue";
// import { getImgUrl, leaderData } from "../../utils/dummy";
import { PENDING_USER_SEARCH } from "../../store/actions.names";
import { namespaced, NS_ADMIN } from "../../store/namespace";
import debounce from "debounce";

@Component({
  name: "PendingUser",
  components: {
    Button,
    FilterBox,
    SinglePeoplePending
  }
})
export default class PendingUser extends Vue {
  @Action(namespaced(NS_ADMIN, PENDING_USER_SEARCH)) pendingUserSearch: any;
  //   leaderData: any = leaderData;
  showModal: boolean = false;
  leaderData: any | null = null;
  public showBox: boolean = false;
  searchText: string = null;
  LIMIT: number = 20;
  currentPage = 1;

  toggleBox() {
    this.showBox = !this.showBox;
  }

  handleNextPage() {
    this.currentPage = this.currentPage + 1;
    const div = Math.ceil(this.leaderData.count / this.LIMIT);
    if (this.currentPage > div) {
      this.currentPage = div
    }
  }

  handlePrevPage() {
    this.currentPage = this.currentPage - 1;
    if (this.currentPage < 1) {
      this.currentPage = 1;
    }
  }

  @Watch("currentPage")
  handlePageChange(val, oldVal) {
    if (val != oldVal) {
      this.fetchUser(this.currentPage)
    }
  }

  fetchUser(page = 1) {
    const offset = this.LIMIT * (page - 1);
    const payload = {
      is_active: false,
      is_declined: false,
      limit: this.LIMIT,
      offset: offset
    }
    this.pendingUserSearch(payload)
      .then(data => {
        this.$set(this, 'leaderData', { ...data, updatedOn: (new Date()).toISOString() });
      })
      .catch(e => {
        // console.log(e);
      });
  }

  searchUsers = debounce((evt) => {
    this.search(evt);
  }, 200)

  search(evt) {
    if (evt.target.value.length > 2) {
      const payload = {
        is_active: false,
        is_declined: false,
        limit: this.LIMIT,
        offset: 0,
        search: evt.target.value
      };
      this.pendingUserSearch(payload)
        .then((users) => {
          console.log("setting", users);
          this.$set(this, 'leaderData', { ...users, updatedOn: (new Date()).toISOString() });

          // this.leaderData = users;
        })
    } else {
      this.fetchUser(this.currentPage);
    }
  }

  updateAssigneeList() {
    this.fetchUser();
  }

  mounted() {
    this.fetchUser();
  }

}
